export function formatTgl(tgl) {
  const date = new Date(tgl);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  const format = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  return format;
}

export function truncateLongText(text, max = 20) {
  try {
    const maxWord = max;
    const word = text.split(" ");
    if (word.length > maxWord) {
      return word.slice(0, maxWord).join(" ") + "...";
    }
    return text;
  } catch (error) {
    return "error";
  }
}

export function formatTanggal(tgl, option = {}) {
  try {
    const date = new Date(tgl);

    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      ...option,
    };

    const localizedDate = date.toLocaleString("id-ID", options);

    return localizedDate;
  } catch (error) {
    return "null";
  }
}

export function removeNulls(obj) {
  if (Array.isArray(obj)) {
    return obj.filter((item) => item !== null).map((item) => removeNulls(item));
  } else if (typeof obj === "object" && obj !== null) {
    return Object.fromEntries(
      Object.entries(obj)
        .filter(([key, value]) => value !== null)
        .map(([key, value]) => [key, removeNulls(value)])
    );
  } else {
    return obj;
  }
}

export function currencyChange(number) {
  try {
    return number.toLocaleString("id-ID");
  } catch (error) {
    return "0";
  }
}

export const showSuccess = (toast, detail = null) => {
  toast.current.show({ severity: "success", summary: "Success", detail: detail, life: 3000 });
};
export const showError = (toast, details = null) => {
  toast.current.show({ severity: "error", summary: "Error", detail: details, life: 2500 });
};
